import { useEffect, useState } from 'react';

let nextId = 0;

const useFacets = (initialFacets) => {
  const [facets, setFacets] = useState([]);

  const addFacet = (newFacet) => {
    let facetToUpdate = newFacet;
    if (!newFacet.id) {
      facetToUpdate = {
        id: nextId += 1,
        ...newFacet,
      };
    }
    setFacets(
      [
        ...facets,
        facetToUpdate,
      ],
    );
  };

  const updateFacet = (updatedFacet) => {
    const index = facets.findIndex((facet) => facet.id === updatedFacet.id);
    if (index === -1) {
      addFacet(updatedFacet);
    } else {
      setFacets((prevFacets) => {
        const updatedFacets = [...prevFacets];
        updatedFacets[index] = {
          ...updatedFacet,
          id: updatedFacets[index].id,
        };
        return updatedFacets;
      });
    }
  };

  const removeFacet = (index) => {
    setFacets((prevFacets) => {
      const updatedFacets = [...prevFacets];
      updatedFacets.splice(index, 1);
      return updatedFacets;
    });
  };

  const clearFacets = () => {
    setFacets([]);
  };

  useEffect(() => {
    if (initialFacets.length > 0) {
      const initialFacetsWithIds = initialFacets
      // eslint-disable-next-line no-return-assign
        .map((facet) => ({ ...facet, id: (facet.id ? facet.id : nextId += 1) }));
      setFacets(initialFacetsWithIds);
    }
  }, []);

  return {
    facets,
    setFacets,
    updateFacet,
    removeFacet,
    addFacet,
    clearFacets,
  };
};

export default useFacets;
